// ONB-002 — espejo en el cliente de la política del servidor (backend/src/infrastructure/utils/password.ts),
// solo para avisar antes de enviar; la que manda es la del servidor. Hay dos formas válidas de contraseña:
//   - la contraseña de una cuenta creada por el registro: 8+ caracteres con letras y números (hasta 72
//     bytes, el límite de bcrypt);
//   - el PIN histórico de 4 a 8 números (empleados y negocios creados por Plataforma).

const LEGACY_PIN = /^\d{4,8}$/;
export const ACCOUNT_PASSWORD_MIN_LENGTH = 8;
const ACCOUNT_PASSWORD_MAX_BYTES = 72;

export const ACCOUNT_PASSWORD_HINT = 'Al menos 8 caracteres, con letras y números.';

const byteLength = (value: string) => new TextEncoder().encode(value).length;

export const isLegacyPin = (value: string): boolean => LEGACY_PIN.test(value);

export function isAccountPassword(value: string): boolean {
  return value.length >= ACCOUNT_PASSWORD_MIN_LENGTH && byteLength(value) <= ACCOUNT_PASSWORD_MAX_BYTES && /\p{L}/u.test(value) && /\d/.test(value);
}

export const isValidPassword = (value: string): boolean => isLegacyPin(value) || isAccountPassword(value);

/** Qué le falta a una contraseña de cuenta nueva, dicho en palabras; undefined si está bien. */
export function accountPasswordProblem(value: string): string | undefined {
  if (value.length < ACCOUNT_PASSWORD_MIN_LENGTH) return 'Usa al menos 8 caracteres.';
  if (byteLength(value) > ACCOUNT_PASSWORD_MAX_BYTES) return 'Es demasiado larga: usa una más corta.';
  if (!/\p{L}/u.test(value)) return 'Agrega al menos una letra.';
  if (!/\d/.test(value)) return 'Agrega al menos un número.';
  return undefined;
}
